import { withTranslation } from "next-i18next";
import { useReloadCustomizableCloset, useCurrentClosetBackToRTC } from "@hooks/use-customizable-closet";
import { useCloseDrawer } from "@hooks/use-drawer";
import useCustomizableCloset from "@hooks/use-customizable-closet";
import Button from "@components/core/Button";
import ClosetItemsList from "@components/core/ClosetItemsList";

function DrawerClosetRTP({ t }) {
  const currentCloset = useCustomizableCloset();
  const closeDrawer = useCloseDrawer();
  const currentClosetBackToRTC = useCurrentClosetBackToRTC();
  const reloadCustomizableCloset = useReloadCustomizableCloset();

  async function backToRTC() {
    try {
      await currentClosetBackToRTC();
    } catch (error) {
      closeDrawer();
      reloadCustomizableCloset();
    }
  }

  return (
    <div>
      <div className="d-flex flex-column align-items-center bg-white py-3 px-4 text-center">
        <h5 className="px-2 mb-2">
          {t('common:drawer.modal_closet_rtp.your_closet_is_validated')}
        </h5>
        <p className="px-2 mb-2">
          {t('common:drawer.modal_closet_rtp.last_chance_before_preparation')}
        </p>
        <Button
          variant="link-primary"
          className="mx-auto font-weight-medium no-underline"
          onClick={backToRTC}
        >
          {t("common:drawer.modal_closet_rtp.change_my_selection")}
        </Button>
      </div>

      <div className="m-2">
        <ClosetItemsList closet={currentCloset} />
      </div>
    </div>
  );
};

export default withTranslation("common")(DrawerClosetRTP);
